module.exports = __webpack_public_path__ + "img/ai-btn-icon.bf238136.svg";